export class HeaderService {
  public async getHeaderProps() {
    return {
      headerTitle: "Notes",
      refreshButton: {
        id: "refresh",
        label: "Refresh",
        icon: "RefreshIcon",
      },
    };
  }
}
